// Tiny classname joiner for the ui library.
export default function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}
